"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Localize_1 = require("../../../gen-src/Localize");
function messageForConnectionType(connectionType) {
    if (!connectionType) {
        return connectionType;
    }
    var messageKey = connectionTypeToMessageKey(connectionType);
    var MessagesMap = Localize_1.Messages;
    return MessagesMap.hasOwnProperty(messageKey) ? MessagesMap[messageKey]() : connectionType;
}
exports.messageForConnectionType = messageForConnectionType;
// This method is also used to generate the connection type messages so
// make the sure the connection type can be a legal javascript function name
// NOTE: After modifying this method, run `yarn run generate-connection-type-messages` and merge in the modified messages files
function connectionTypeToMessageKey(connectionType) {
    return 'CONNECTION_TYPE_' + connectionType.replace(/:|-/g, '_');
}
exports.connectionTypeToMessageKey = connectionTypeToMessageKey;
//# sourceMappingURL=MessageUtils.js.map